import moment from "moment"
import Link from "next/link"
import { createObjectPagePathname, getMediaUrl } from "@/services/pathname"
import img from "@/assets/img/gallery/hebergement-1.jpg"
import 'moment/locale/fr'
import { getName } from "@/services/aroeven"
import { getMediasBySector } from "@/services/accomodation"
moment.locale('fr')

type CardProps = {
    accomodation: Accomodation,
    sector?: string
}

export default function Card({
    accomodation,
    sector = 'Rental'
}: CardProps) {

    return (
        <Link className="vignette -type-1 h-100" href={createObjectPagePathname('Accomodation', accomodation)} >
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        <img className="col-12" src={getMediasBySector(accomodation, 'rental').filter(media => media.mimeType.indexOf('image/') === 0)[0]?.url ?? '#'} alt="image" loading="lazy" />
                    </div>
                </div>
                <div className="bandeau">
                    <i className="fi fi-rr-bed" /> Hébergement
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <p className="text-light-1 lh-14 text-13 mt-5 mb-0">
                            <i className="fi fi-rr-marker text-primary-4" /> {accomodation.address.city} ({accomodation.address.postCode.slice(0, 2)})
                        </p>
                        <h4 className="vignette__title py-10">
                            {accomodation.name}
                        </h4>
                        <ul className="equipements mb-10">
                            {accomodation.capacity && <li>{accomodation.capacity} places</li>}
                            {accomodation.rentalHasBedLinenRental &&<li>Location literie</li>}
                            {accomodation.rentalHasEndOfStayCleaning && <li>Ménage de fin de séjour</li>}
                        </ul>
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className="lh-1 mb-5">Proposé par {getName(accomodation.proposedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}